export default function AttachFindingReportDirective() {
  return {
    template: require('./attach-finding-report.html'),
    scope: {
      findingId: '=',
      serviceId: '=',
      reportId: '=',
      report: '=',
    },
    controller: 'AttachFindingReportController',
    controllerAs: 'attachFindingReportVM',
    bindToController: true,
    replace: true
  };
}
